var map = {
	"./ExchangeFormPage.vue": [
		"72a8",
		"chunk-58a4e668",
		"chunk-ee2f356c"
	],
	"./LandingPage.vue": [
		"d115",
		"chunk-2414e4ab"
	],
	"./PaymentPage.vue": [
		"421b",
		"chunk-58a4e668",
		"chunk-85523ed6"
	],
	"./TransactionsHistory.vue": [
		"7268",
		"chunk-a0129eac"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;